import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';
import { CATALOGUE_CONFIG } from '../catalogue/catalogue.types';
import { BULLET_CATALOGUE } from './bullet.config';

export const bulletsRoutes: Routes = [
  {
    path: 'bullets',
    providers: [{ provide: CATALOGUE_CONFIG, useValue: BULLET_CATALOGUE }],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../catalogue/catalogue-list/catalogue-list.component').then((m) => m.CatalogueListComponent),
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/bullet-create/bullet-create.component').then((m) => m.BulletCreateComponent),
        canActivate: [adminGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../catalogue/catalogue-detail/catalogue-detail.component').then((m) => m.CatalogueDetailComponent),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/bullet-edit/bullet-edit.component').then((m) => m.BulletEditComponent),
        canActivate: [adminGuard],
      },
    ],
  },
];
